import axios from 'axios';
import EmailRequest from '../models/EmailRequest';

const url = process.env.REACT_APP_API_URL;

export const EmailService = {
  Send: async (emailRequest: EmailRequest) => {
    const response = await axios.post(
      `${url}/email/send`,
      emailRequest
    );
    return response;
  },
};
